import { motion } from "framer-motion";
import { STATS } from "@/data/content";
import { staggerParent, staggerChild } from "@/components/motion-primitives";

export const TrustBand = () => (
  <section className="relative z-20 -mt-px bg-brand-dark grain border-t border-white/5">
    <div className="container mx-auto px-4 md:px-8 py-14 md:py-16">
      <motion.div
        variants={staggerParent} initial="hidden" whileInView="show" viewport={{ once: true }}
        className="grid grid-cols-2 lg:grid-cols-4 divide-y sm:divide-y-0 sm:divide-x divide-white/10 gap-y-8 sm:gap-y-0"
      >
        {STATS.map((s, i) => (
          <motion.div key={i} variants={staggerChild} data-testid={`stat-${i}`} className="px-4 sm:px-8 first:pl-0">
            <div className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-white tracking-tight">
              {s.value}{s.unit && <span className="text-secondary"> {s.unit}</span>}
            </div>
            <div className="mt-2 text-xs md:text-sm text-white/55 leading-snug max-w-[200px]">{s.label}</div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);
